import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { thousandSeparator } from '../../utils/Utils'

// Import React Table
import ReactTable from 'react-table'
import 'react-table/react-table.css'

const styles = theme => ({
  tableWrapper: {
    maxWidth: '990px',
    margin: '5px auto 20px auto',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
    overflow: 'hidden',
    paddingBottom: 16,
  },
  tableTitle: {
    fontSize: '14px',
    textAlign: 'center',
    padding: '15px 0',
  },
  historyTable: {
    backgroundColor: '#fff',
    borderRadius: 4,
    overflow: 'hidden',
    boxShadow:
      '0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
    '& .ReactTable': {
      maxHeight: 510,
    },
    '& .ReactTable .rt-thead .rt-th': {
      justifyContent: 'center',
    },
    '& .ReactTable .rt-table': {
      overflow: 'auto',
    },
    '& .ReactTable .rt-tbody .rt-td': {
      justifyContent: 'center',
    },
  },
  paymentError: {
    color: '#ff4e44',
  },
  paymentSuccess: {
    color: 'rgb(95, 71, 178)',
  },
  tableWraper: {
    padding: 16,
  },
})

class PaymentHistoryTable extends Component {
  state = {
    data: this.props.data,
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        data: this.props.data,
      })
    }
  }

  render() {
    const { classes } = this.props
    const { data } = this.state

    return (
      <div className={classes.historyTable}>
        <ReactTable
          data={data}
          pageSize={this.props.data.length}
          showPagination={false}
          sortable={false}
          columns={[
            {
              Header: 'Дата',
              accessor: 'date',
            },
            {
              Header: `Сумма`,
              id: 'amount',
              accessor: d => Number(d.amount).toFixed(2),
              Cell: ({ value }) => {
                return `${thousandSeparator(Number(value).toFixed(2))} ₽`
              },
            },
            {
              Header: 'Статус',
              id: 'status',
              accessor: d => d.status,
              Cell: ({ value }) => {
                switch (value) {
                  case 'confirmed':
                    return <span className={classes.paymentSuccess}>Оплачено</span>
                  case 'refunded':
                  case 'partial_refunded':
                    return <span className={classes.paymentSuccess}>Возврат платежа</span>
                  case 'reversed':
                    return <span className={classes.paymentSuccess}>Платеж отменен</span>
                  case 'rejected':
                    return <span className={classes.paymentSuccess}>Ошибка платежа</span>
                  default:
                    return <span className={classes.paymentSuccess}>Неизвестный статус</span>
                }
              },
            },
          ]}
          className="-striped -highlight"
        />
      </div>
    )
  }
}

export default withStyles(styles)(PaymentHistoryTable)
